import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-employees-docs-importer',
  templateUrl: './employees-docs-importer.component.html',
  styleUrls: ['./employees-docs-importer.component.css']
})
export class EmployeesDocsImporterComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    this.router.navigate(['/employees']);
  }
}
